module.exports = __webpack_public_path__ + "static/media/pl.96f4898b.png";